/*
 * Dauerhaft sichtbare horizontale Scrollleiste fuer .dialogblock mit Tabelle.
 *
 * Mobile Browser blenden ihre Overlay-Scrollbars nach dem Wischen aus, der Nutzer sieht dann
 * nicht, dass die Tabelle weitere Spalten hat. Dieses Modul haengt eine eigene Leiste (Track +
 * Thumb) direkt hinter den scrollbaren Wrapper. Die Leiste erscheint nur bei echtem Overflow.
 *
 * Bewusst ES5 (Vorgabe: aeltere mobile Browser), daher die abgeschalteten airbnb-Regeln.
 * Der Inhalt wird vom Portal per AJAX (innerHTML) ausgetauscht, deshalb gibt es keine
 * einmalige Initialisierung, sondern einen Abgleich bei jeder DOM-/Groessenaenderung.
 * CSS: Scss/iframe.scss, Abschnitt "custom scrollbar".
 */
/* eslint-disable no-var, vars-on-top, prefer-arrow-callback, object-shorthand,
  prefer-template, prefer-destructuring, no-plusplus, no-use-before-define, strict, quotes,
  comma-dangle, space-before-function-paren, func-names, no-param-reassign */
(function () {
  'use strict';

  var SELECTOR = '.dialogblock';
  var MIN_THUMB = 30;
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';
  var instances = [];
  var scheduled = false;
  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }
  function schedule() {
    if (scheduled) {
      return;
    }
    scheduled = true;
    var run = function () {
      scheduled = false;
      sync();
    };
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(run);
    } else {
      window.setTimeout(run, 16);
    }
  }
  function createInstance(el) {
    var track = document.createElement('div');
    var thumb = document.createElement('div');
    var self = {
      el: el,
      track: track,
      active: false,
      madeFocusable: false,
      ro: null
    };
    var dragging = false;
    var startX = 0;
    var startScroll = 0;
    track.className = 'custom-scrollbar-track';
    track.setAttribute('aria-hidden', 'true');
    track.hidden = true;
    thumb.className = 'custom-scrollbar-thumb';
    track.appendChild(thumb);
    function metrics() {
      var max = el.scrollWidth - el.clientWidth;
      var trackWidth = track.clientWidth;
      var thumbWidth = el.scrollWidth > 0 ? clamp(trackWidth * (el.clientWidth / el.scrollWidth), MIN_THUMB, trackWidth) : trackWidth;
      return {
        max: max,
        trackWidth: trackWidth,
        thumbWidth: thumbWidth,
        maxLeft: trackWidth - thumbWidth
      };
    }
    function updateThumb() {
      var m = metrics();
      var ratio = m.max > 0 ? el.scrollLeft / m.max : 0;
      var x = clamp(ratio, 0, 1) * m.maxLeft;
      thumb.style.width = m.thumbWidth + 'px';
      thumb.style.webkitTransform = 'translateX(' + x + 'px)';
      thumb.style.transform = 'translateX(' + x + 'px)';
    }

    // Tastatur: Ein Scroll-Container ohne fokussierbaren Inhalt ist per Tab nicht erreichbar.
    // Nur dann machen wir ihn fokussierbar; sonst bleibt die Tab-Reihenfolge unangetastet.
    function setKeyboardAccess(on) {
      if (on && !el.hasAttribute('tabindex') && !el.querySelector(FOCUSABLE)) {
        el.setAttribute('tabindex', '0');
        el.setAttribute('role', 'region');
        el.setAttribute('aria-label', 'Tabelle, horizontal scrollbar');
        self.madeFocusable = true;
      } else if (!on && self.madeFocusable) {
        el.removeAttribute('tabindex');
        el.removeAttribute('role');
        el.removeAttribute('aria-label');
        self.madeFocusable = false;
      }
    }
    self.update = function () {
      var overflow = el.scrollWidth - el.clientWidth > 1;

      // Leiste immer direkt hinter dem Wrapper halten (Portal baut den Bereich um).
      if (track.parentNode !== el.parentNode || el.nextSibling !== track) {
        el.parentNode.insertBefore(track, el.nextSibling);
      }
      if (overflow !== self.active) {
        self.active = overflow;
        track.hidden = !overflow;
        // Native Scrollbar nur ausblenden, solange die eigene Leiste sichtbar ist.
        el.classList.toggle('has-custom-scrollbar', overflow);
        setKeyboardAccess(overflow);
      }
      if (overflow) {
        updateThumb();
      }
    };
    function scrollToThumbLeft(left) {
      var m = metrics();
      if (m.maxLeft > 0) {
        el.scrollLeft = clamp(left, 0, m.maxLeft) / m.maxLeft * m.max;
        updateThumb();
      }
    }
    function jumpTo(clientX) {
      // Thumb mittig unter den Zeiger setzen
      scrollToThumbLeft(clientX - track.getBoundingClientRect().left - thumb.offsetWidth / 2);
    }
    function begin(clientX, onThumb) {
      if (!onThumb) {
        jumpTo(clientX);
      }
      dragging = true;
      startX = clientX;
      startScroll = el.scrollLeft;
      track.classList.add('is-dragging');
    }
    function move(clientX) {
      var m = metrics();
      if (dragging && m.maxLeft > 0) {
        el.scrollLeft = startScroll + (clientX - startX) / m.maxLeft * m.max;
        updateThumb();
      }
    }
    function end() {
      dragging = false;
      track.classList.remove('is-dragging');
    }

    // Touch/Stift auf dem freien Track: erst beim Loslassen springen, und nur bei einem Tap.
    // Beginnt dort ein vertikales Wischen, scrollt die Seite und die Tabelle bleibt stehen.
    var tap = null;
    function tapStart(x, y) {
      tap = {
        x: x,
        y: y
      };
    }
    function tapMove(x, y) {
      if (tap && (Math.abs(x - tap.x) > 8 || Math.abs(y - tap.y) > 8)) {
        tap = null;
      }
    }
    function tapEnd() {
      if (tap) {
        jumpTo(tap.x);
        tap = null;
      }
    }
    el.addEventListener('scroll', updateThumb, false);
    if (window.PointerEvent) {
      track.addEventListener('pointerdown', function (e) {
        var onThumb = e.target === thumb;
        if (e.pointerType === 'mouse' && e.button !== 0) {
          return;
        }
        if (onThumb || e.pointerType === 'mouse') {
          begin(e.clientX, onThumb);
          if (track.setPointerCapture) {
            track.setPointerCapture(e.pointerId);
          }
          e.preventDefault();
        } else {
          tapStart(e.clientX, e.clientY);
        }
      });
      track.addEventListener('pointermove', function (e) {
        move(e.clientX);
        tapMove(e.clientX, e.clientY);
      });
      track.addEventListener('pointerup', function () {
        end();
        tapEnd();
      });
      track.addEventListener('pointercancel', function () {
        end();
        tap = null;
      });
      track.addEventListener('lostpointercapture', end);
    } else {
      // Fallback fuer Browser ohne Pointer Events (iOS < 13, alte Android-WebViews)
      track.addEventListener('touchstart', function (e) {
        var t = e.touches[0];
        if (e.target === thumb) {
          begin(t.clientX, true);
          e.preventDefault();
        } else {
          tapStart(t.clientX, t.clientY);
        }
      }, false);
      track.addEventListener('touchmove', function (e) {
        var t = e.touches[0];
        if (dragging) {
          move(t.clientX);
          e.preventDefault();
        } else {
          tapMove(t.clientX, t.clientY);
        }
      }, false);
      track.addEventListener('touchend', function () {
        end();
        tapEnd();
      }, false);
      track.addEventListener('touchcancel', function () {
        end();
        tap = null;
      }, false);
      track.addEventListener('mousedown', function (e) {
        var onMove = function (ev) {
          move(ev.clientX);
        };
        var onUp = function () {
          end();
          document.removeEventListener('mousemove', onMove, false);
          document.removeEventListener('mouseup', onUp, false);
        };
        if (e.button !== 0) {
          return;
        }
        begin(e.clientX, e.target === thumb);
        document.addEventListener('mousemove', onMove, false);
        document.addEventListener('mouseup', onUp, false);
        e.preventDefault();
      }, false);
    }
    self.destroy = function () {
      el.removeEventListener('scroll', updateThumb, false);
      if (self.ro) {
        self.ro.disconnect();
      }
      setKeyboardAccess(false);
      el.classList.remove('has-custom-scrollbar');
      if (track.parentNode) {
        track.parentNode.removeChild(track);
      }
    };
    if (window.ResizeObserver) {
      self.ro = new window.ResizeObserver(schedule);
      self.ro.observe(el);
      var table = el.querySelector('table');
      if (table) {
        self.ro.observe(table);
      }
    }
    return self;
  }
  function find(el) {
    var i;
    for (i = 0; i < instances.length; i++) {
      if (instances[i].el === el) {
        return instances[i];
      }
    }
    return null;
  }
  function sync() {
    var els = document.querySelectorAll(SELECTOR);
    var i;
    var inst;

    // Vom Portal ersetzte Container aufraeumen
    for (i = instances.length - 1; i >= 0; i--) {
      if (!document.documentElement.contains(instances[i].el)) {
        instances[i].destroy();
        instances.splice(i, 1);
      }
    }
    for (i = 0; i < els.length; i++) {
      if (!find(els[i]) && els[i].querySelector('table')) {
        instances.push(createInstance(els[i]));
      }
    }

    // Verwaiste Leisten entfernen, z. B. wenn ein Austausch des Inhalts sie mitkopiert hat.
    var tracks = document.querySelectorAll('.custom-scrollbar-track');
    var j;
    for (i = 0; i < tracks.length; i++) {
      var owned = false;
      for (j = 0; j < instances.length; j++) {
        if (instances[j].track === tracks[i]) {
          owned = true;
        }
      }
      if (!owned) {
        tracks[i].parentNode.removeChild(tracks[i]);
      }
    }
    for (i = 0; i < instances.length; i++) {
      inst = instances[i];
      inst.update();
    }
  }
  function start() {
    sync();
    window.addEventListener('resize', schedule, false);
    window.addEventListener('orientationchange', schedule, false);
    window.addEventListener('load', schedule, false);
    if (document.fonts && document.fonts.addEventListener) {
      document.fonts.addEventListener('loadingdone', schedule);
    }
    if (window.MutationObserver) {
      new window.MutationObserver(schedule).observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, false);
  } else {
    start();
  }
})();